import { get as _get } from 'lodash';
import { v4 as uuid } from 'uuid';

export async function getMakes(urlKey: string, sessionId: string, custKey: string, year: string) {
  if (!year) {
    return [];
  }
  try {
    const headers = new Headers();
    headers.append('urlid', urlKey);
    headers.append('afe-session-id', sessionId);
    headers.append('Authorization', 'Bearer ' + custKey);
    headers.append('content-type', 'application/json');
    headers.append('afe-trace-id', uuid());

    const URI = `${process.env['NX_DCV2_API_BASE_URL']}vehicle/v1/makes?year=${year}&typeOfVehicleCode=automobile`;
    const response = await fetch(URI, {
      method: 'GET',
      headers: headers,
    });
    if (response.status >= 200 && response.status <= 299) {
      const responseData = await response.json();
      return _get(responseData, 'data.makes', []);
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
}

export async function getModels(urlKey: string, sessionId: string, custKey: string, year: string, make: string) {
  if (!year || !make) {
    return [];
  }
  try {
    const headers = new Headers();
    headers.append('urlid', urlKey);
    headers.append('afe-session-id', sessionId);
    headers.append('Authorization', 'Bearer ' + custKey);
    headers.append('content-type', 'application/json');
    headers.append('afe-trace-id', uuid());

    const URI = `${process.env['NX_DCV2_API_BASE_URL']}vehicle/v1/models?year=${year}&make=${make}&typeOfVehicleCode=automobile`;
    const response = await fetch(URI, {
      method: 'GET',
      headers: headers,
    });
    if (response.status >= 200 && response.status <= 299) {
      const responseData = await response.json();
      return _get(responseData, 'data.models', []);
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
}
